import { Box, TextField, Typography, useTheme } from "@mui/material";
import React, { useContext } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";


function LocationSearchField({
  searchType,
  p,
  textColor,
  address,
  placeholder,
  handleAddress,
  updateLatLng,
  onChange,
  onBlur,
  disabled = false,
  width,
  className,
  name,
  error, // Add error prop
  touched, // Add touched prop
}) {
  const theme = useTheme();
  
  const handleSelect = (address) => {
    handleAddress(address);
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => updateLatLng(latLng))
      .catch((error) => console.error("Error", error));
  };

  const typesToSearch = searchType
    ? [searchType]
    : ["geocode", "establishment"];

  return (
    <PlacesAutocomplete
      value={address}
      onChange={(value) => {
        handleAddress(value);
        onChange({ target: { name, value } }); // Trigger Formik's onChange
      }}
      onSelect={(value) => {
        handleSelect(value);
        onBlur({ target: { name } }); // Trigger Formik's onBlur
      }}
      searchOptions={{
        types: typesToSearch,
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Box
          width={width}
          borderRadius="12px"
          display="flex"
          justifyContent="start"
          alignItems="center"
          py="12px"
          position={"relative"}
        >
          <Box
            className={className || ""}
            sx={{ border: "none", mt: -1, mb: -1 }}
            width="100%"
          >
            <TextField
              type="text"
              id="location"
              name={name}
              // error={touched && Boolean(error)}
              // helperText={touched && error}
              sx={{
                mb: 0.5,
                "& .MuiOutlinedInput-notchedOutline ": {
                  outline: "none",
                  border: "none",
                },
                borderRadius: "20px",
                border: "none",
                outline: "none",
                background: "#f3f3f3",
                width: "100%",
              }}
              {...getInputProps({
                disabled: disabled,
                placeholder: placeholder || "Enter Address",
                className: "location-search-input",
                onBlur: () => onBlur({ target: { name } }), // Ensure onBlur is called
              })}
              InputLabelProps={{
                shrink: true,
              }}
              className="form-control"
              placeholder={"Location"}
            />

            <Box
              sx={{
                width: "100%",
                minWidth: "285px",
                display: suggestions.length ? "block" : "none",
                bgcolor: "#f3f3f3",
                borderRadius: "12px",
                p: 1,
                boxSizing: "border-box",
                zIndex: 99999,
                position: "absolute",
                fontSize: "22px",
                fontFamily: "Roboto",
              }}
            >
              {loading && <div>Loading...</div>}
              {suggestions.map((suggestion) => {
                const className = suggestion?.active
                  ? "suggestion-item--active"
                  : "suggestion-item";
                return (
                  <Box
                    sx={{
                      color: textColor,
                      textAlign: "left",
                      cursor: "pointer",
                      borderBottom: "solid 0.01px",
                      borderBottomColor: "divider",
                      fontSize: "1rem",
                      p: "1rem 0",
                    }}
                    width={"100%"}
                    key={suggestion?.description}
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                  >
                    <Typography
                      sx={{
                        color:
                          theme.palette.mode === "light"
                            ? `${suggestion?.active ? "#1f243870" : "#1f2438"}`
                            : `${suggestion?.active ? "#ffffff70" : "#fff"}`,
                      }}
                      variant="subtitle2"
                    >
                      {suggestion?.description}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Box>
      )}
    </PlacesAutocomplete>
  );
}

export default LocationSearchField;
